import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import StyleModule from './modules/StyleModule'
import StoreModule from './modules/StoreModule'
import RouteModule from './modules/RouteModule'
import ComponentsModule from './modules/ComponentsModule'
import PrototypesModule from './modules/PrototypesModule'
import MemberModule from './modules/MemberModule'
import OrderModule from './modules/OrderModule'
import NotificationModule from './modules/NotificationModule'
import StockLocationModule from './modules/StockLocationModule'
import StockMappingModule from './modules/StockMappingModule'
import WarehouseWorkTrackerModule from './modules/WarehouseWorkTrackerModule'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  restoreState: (key, storage) => {
    const data = storage[key] ? JSON.parse(storage[key]) : {}
    if (data?.Order?.orderIdSelected) {
      delete data.Order.orderIdSelected
      delete data.Order.statusList
    }
    return data
  },
  modules: ['Store', 'Style', 'Prototypes', 'Member', 'Order', 'StockLocation', 'StockMapping', 'WarehouseWorkTracker']
})

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Components: ComponentsModule,
    Route: RouteModule,
    Store: StoreModule,
    Style: StyleModule,
    Prototypes: PrototypesModule,
    Member: MemberModule,
    Order: OrderModule,
    Notification: NotificationModule,
    StockLocation: StockLocationModule,
    StockMapping: StockMappingModule,
    WarehouseWorkTracker: WarehouseWorkTrackerModule
  },
  plugins: [
    vuexLocal.plugin
  ]
})
